const ServiceIntervalEnum = {
  Weekly: {
    id: 1,
    name: "Weekly",
  },
  Monthly: {
    id: 2,
    name: "Monthly",
  },
  Yearly: {
    id: 3,
    name: "Yearly",
  },
};

export default ServiceIntervalEnum;
